// Team-related filters

import { createEntityLookupFilter, createKeywordFilter } from './factories';
import type { FilterRegistry } from './types';

export const teamFilters: FilterRegistry = {
	teamKeywords: {
		...createKeywordFilter({
			label: 'Keywords',
			placeholder: 'Search by team name...',
			objectTable: 'team',
			listKeys: ['team'],
			fulltextFields: ['team_name'],
		}),
		queryParamName: 'teamKeywords',
	},

	/*
	 * PD-16315 — team types are configured per tenant on Settings → Team
	 * Settings, so the options are fetched rather than listed here. A static
	 * option list would go stale the first time somebody added a type.
	 */
	teamType: {
		...createEntityLookupFilter({
			label: 'Type',
			placeholder: 'Select type...',
			apiEndpoint: '/team-settings/types',
			objectTable: 'team',
			fieldName: 'fkTeamTypeId',
			listKeys: ['team'],
			displayFields: {
				id: 'id',
				primary: 'name',
			},
		}),
		queryParamName: 'teamType',
		valueExtractor: {
			property: 'id',
			transform: 'number',
		},
	},
};
